import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../lib/ThemeContext';

export function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  
  const handleToggle = () => {
    // Check if OneTrust is available and functional cookies are allowed
    const hasConsentForFunctional = window.OnetrustActiveGroups?.includes('C0002');
    
    // If OneTrust is not loaded yet or functional cookies are allowed, toggle theme
    if (!window.OneTrust || hasConsentForFunctional) {
      toggleTheme();
    } else {
      // If functional cookies are not allowed, show OneTrust preference center
      if (window.OneTrust?.ToggleInfoDisplay) {
        window.OneTrust.ToggleInfoDisplay();
      }
    }
  };
  
  return (
    <button
      onClick={handleToggle}
      className="flex items-center w-full text-gray-700 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 hover:bg-gray-50 dark:hover:bg-gray-800 px-4 py-2 rounded-md transition-colors duration-200"
      aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
    >
      {theme === 'light' ? (
         <>
          <Moon className="h-4 w-4 mr-2" />
          <span>Dark Mode</span>
        </>
      ) : (
        <>
          <Sun className="h-4 w-4 mr-2" />
          <span>Light Mode</span>
        </>
      )}
    </button>
  );
}